import * as S from "./bottomNavigation.styles";
import { navMenu } from "../../../data/dummy";
import { BottomNavItem } from "../../atoms/BottomNavItem";

interface BottomNavigationProps {}
export const BottomNavigation = ({}: BottomNavigationProps) => {
  return (
    <S.BottomNav>
      <S.BottomNavList>
        {navMenu?.map((item: any, idx: number) => {
          return (
            <BottomNavItem
              icon={idx}
              menuTitle={item.menuTitle}
              url={item.url}
              key={idx}
            />
          );
        })}
      </S.BottomNavList>
    </S.BottomNav>
  );
};
